export const Role = {
  SuperAdmin: "Super Admin",
  HoManager: "HO Manager",
  CinemaManager: "Cinema Manager",
  PosOperator: "POS Operator",
  // PosOperator: 'POS Operator',
  PosFnBOperator: "FnB POS Operator",
  Distributor: "Distributor",
  BoxOfficeFnbOperator: "Box Office Fnb",
  AnalyticsManager: "Analytics Manager",
  KitchenManager: "Kitchen Manager",
  ProgrammingManager: "Programming Manager",
};

export const CLIENT_NAME = {
  ROONGTA: "roongta",
  EPIX: "epix",
  CINEPOLIS_OMAN: "cinepolis-oman",
  CINEPOLIS_KSA: "cinepolis-ksa",
  CINEMA_AKIL: "epix",
  EMPIRE: "empire",
  STUESSIHOF: "stuessihof",
  XANADU: "xanadu",
  PETRO: "petro",
  IRAQ: "Iraq",
  LEBANON: "lebanon",
  BILDHAUS: "bildhaus",
  STAR: "starcinemas",
  QFX: "qfx",
  WOW: "wow",
  DESIRASOI: "desi-rasoi",
  PLAYCINEMA: "playcinema",
  CINERJI: "cinerji",
  MIF:"mif"
};

export const CLIENT_NAMES_OBJ = {
  ROONGTA: ["roongta"],
  EPIX: ["epix"],
  exclusive_tax_structure: ["epix", "wow"],
  cinepolis_combo: ["cinepolis-oman", "cinepolis-ksa"],
  empire_combo: ["empire", "petro", "Iraq", "star", "lebanon"],
  empire_iraq: ["empire", "Iraq"],
  performance_report_combo: [
    "empire",
    "Iraq",
    "lebanon",
    "starcinemas",
    "bildhaus",
  ],
  empire_iraq_lebanon: ["empire", "Iraq", "lebanon", "bildhaus"],
  iraq: ["Iraq"],
  empire: ["empire"],
  xanadu: ["xanadu"],
  petro: ["petro"],
  stuessihof: ["stuessihof"],
  lebanon: ["lebanon"],
  bildhaus: ["bildhaus"],
  wow: ["wow"],
  mif: ["mif"],
  transaction_report_tickets: ["empire", "qfx", "Brij Europe"],
  qfx_tax_structure: ["cinepolis-oman", "cinepolis-ksa", "qfx", "epix"],
  mif_tax_calculation: ["mif"],
  mtax_clients: ["starcinemas", "cinepolis-oman"],
  desiRasoi: ["desi-rasoi"],
  starcinemas: ["starcinemas"],
  allowPartialClosePO: ["starcinemas"],
  has_foreign_movie_options: ["cinepolis-oman", "cinepolis-ksa", "qfx", "mif"],
  QFX:["qfx"],
  show_color_for_aggregators: ["starcinemas", "mif"],
};



// WEBPACK FOOTER //
// ./src/helper/Role.js